import React from "react";
import cursoBrand from '../../assets/images/curso-brand.svg'

import "./index.sass";

const answers = [
    {
        condition: total => total <= 10,
        message: "Você precisa dar uma atenção especial para o seu Perfil no Google Meu Negócio. Você pode estar perdendo oportunidades",
    },
    {
        condition: total => total > 10 && total <= 20,
        message: "Você já começou um trabalho, mas ainda tem um trabalho à realizar. Você pode estar perdendo oportunidades.",
    },
    {
        condition: total => total > 20 && total <= 30,
        message: "Você já está no caminho certo e seus clientes já estão sendo informados sobre sua empresa. Mas ainda pode melhorar!"
    },
    {
        condition: total => total > 30 && total <= 35,
        message: "Poucos ajustes e você terá um Perfil Vendedor! Suas vendas podem ser ainda melhores!",
    },
    {
        condition: total => total > 35,
        message: "Parabéns, você atingiu uma pontuação de Perfil Vendedor!!!",
    },
];

function getPayload (total) {
    return answers.find(each => each.condition(total));
};

function Answer({ loading, total, fullTotal }) {
    const payload = getPayload(total);
    return (
        <div className={`answer ${!loading && total > 0 ? "--active" : ""}`}>
            <div className="header">
                <p className="greeting">Seu perfil marcou</p>
                <div className="points">
                    <span className="point">{total}</span>
                    <span className="total">/{fullTotal} pontos</span>
                </div>
                <p className='desc'>{payload.message}</p>
                <p className="intro">Não sabe por onde começar? <span className="strong">Nós temos o caminho das pedras</span></p>
            </div>
            <div className="video">
                <iframe
                    title="Intro Curso Google Meu Negócio"
                    width="88%"
                    height="240px"
                    src="https://www.youtube.com/embed/-gravOxCB-E"
                    frameBorder="0"
                    allow="encrypted-media;"
                    allowFullScreen
                />
            </div>
            <div className="wrapper">
                <p className="featured">Conheça o nosso curso</p>
                <img className="brand" src={cursoBrand} alt="Eu, o Google e o Meu Negócio"/>
                <div className="action">
                    <p className="label">
                        Inscreva-se agora com
                        <span className="strong">20% de desconto</span>
                    </p>
                    <a href="https://entrecliques.com.br/curso-google-meu-negocio/" className="button">Se Inscrever Agora!</a>
                </div>
            </div>
        </div>
    );
}

export default Answer;
